<template>
  <div style="background-color: #fff;min-height: 100vh;">
    <template v-if="showAll">
      <div class="header-filter">
        <img class="filter-bg" src="./filter-bg.png" />
        <div class="filter-content">
          <div class="split-bar"></div>
          <!-- 年级 -->
          <div class="filter-row1">


            <div class="filter_tabs">
              <div class="filter_tabs_item" @click="() => {
      tabActive = ''
      changeAttendType('')
    }" :class="tabActive === '' ? 'filter_tabs_item_active' : ''">总人数<span style="margin-left: 4px;">{{
      typeNum.personNum || 0 }}</span> </div>
              <div class="filter_tabs_item" @click="() => {
      tabActive = 0
      this.changeAttendType(0)
    }" :class="tabActive === 0 ? 'filter_tabs_item_active' : ''">考勤<span style="margin-left: 4px;">{{
      typeNum.attendanceNum || 0 }}</span></div>
              <div class="filter_tabs_item" @click="() => {
      tabActive = 2
      this.changeAttendType(2)
    }" :class="tabActive == 2 ? 'filter_tabs_item_active' : ''">不考勤<span style="margin-left: 4px;">{{
      typeNum.noAttendanceNum || 0 }}</span></div>
            </div>
            <div class="filter_date">
              <filterDate v-model="filterForm.date" @change="search3()"></filterDate>
              <!-- <div class="filter-input">
              <input placeholder="请输入学生姓名" v-model="filterForm.userName" @change="search()" />
              <div class="search-icon" @click="search()">
                <img src="./search-icon.png" />
                <van-icon name="search" />
              </div>
            </div> -->
              <div class="more-filter" @click="moreFilter">
                <img src="./filter-icon.png" />
              </div>
            </div>

          </div>
          <!-- <div class="split-bar"></div> -->
          <!-- 四种状态 -->
          <div class="split-bar" style="height: 1.2rem;"></div>
          <div class="filter-row3">


            <!-- <div class="type-box">
              <div @click="changeType('')" class="type-item type1" :class="activeType === '' ? 'type1ac' : ''">
                <div class="type-num">{{ typeNum.personNum }}</div>
                <div class="type-name">共计</div>
              </div>
            </div> -->


            <div class="type-box">
              <div @click="changeType(0)" class="type-item type2" :class="activeType === 0 ? 'type2ac' : ''">

                <div class="type-name" :class="activeType === 0 ? 'type-num_active' : ''">
                  <img class="type-img" src="./zaiqin.png" />
                  <span>在寝</span>
                </div>
                <div class="type-num" :class="activeType === 0 ? 'type-num_active' : ''">{{ typeNum.atDormNum }}<span
                    class="type_unit">人</span></div>
              </div>
            </div>
            <div class="type-box">
              <div @click="changeType(1)" class="type-item type3" :class="activeType === 1 ? 'type3ac' : ''">

                <div class="type-name" :class="activeType === 1 ? 'type-num_active' : ''">
                  <img class="type-img" src="./buzaiqin.png" />
                  <span>不在寝</span>
                </div>
                <div class="type-num" :class="activeType === 1 ? 'type-num_active' : ''">
                  {{ typeNum.notDormNum }}
                  <span class="type_unit">人</span>
                </div>
              </div>
            </div>



            <!-- 当前不显示迟离和晚归相关信息 -->
            <template v-if="tabType !== null">
              <template v-if="tabType == 0"></template>
              <template v-else-if="tabType == 1">

                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">

                    <div class="type-name" :class="activeType === 7 ? 'type-num_active' : ''">
                      <img class="type-img" src="./wlwg.png" />
                      <span>迟离</span>
                    </div>
                    <div class="type-num" :class="activeType === 7 ? 'type-num_active' : ''">{{
      typeNum.lateDepartureDormNum }}<span class="type_unit">人</span></div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabType == 2">
                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">

                    <div class="type-name" :class="activeType === 2 ? 'type-num_active' : ''">
                      <img class="type-img" src="./wlwg.png" />
                      <span>晚归</span>
                    </div>
                    <div class="type-num" :class="activeType === 2 ? 'type-num_active' : ''">{{ typeNum.lateDormNum
                      }}<span class="type_unit">人</span></div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">

                    <div class="type-name" :class="activeType === 7 ? 'type-num_active' : ''">
                      <img class="type-img" src="./wlwg.png" />
                      <span>迟离</span>
                    </div>
                    <div class="type-num" :class="activeType === 7 ? 'type-num_active' : ''">{{
      typeNum.lateDepartureDormNum }}<span class="type_unit">人</span></div>
                  </div>
                </div>
                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">

                    <div class="type-name" :class="activeType === 2 ? 'type-num_active' : ''">
                      <img class="type-img" src="./wlwg.png" />
                      <span>晚归</span>
                    </div>
                    <div class="type-num" :class="activeType === 2 ? 'type-num_active' : ''">{{ typeNum.lateDormNum
                      }}<span class="type_unit">人</span></div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="filterForm.timeType[0] == 1 || filterForm.timeType[0] == 3">
                <!-- <div class="type-box">
                  <div @click="changeType(6)" class="type-item type2" :class="activeType === 6 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.normalNumberOfDepartures }}</div>
                    <div class="type-name">正常离寝</div>
                  </div>
                </div> -->
                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">

                    <div class="type-name" :class="activeType === 7 ? 'type-num_active' : ''">迟离</div>
                    <div class="type-num" :class="activeType === 7 ? 'type-num_active' : ''">{{
      typeNum.lateDepartureDormNum }}<span class="type_unit">人</span></div>
                  </div>
                </div>
                <!-- <div class="type-box">
                  <div @click="changeType(8)" class="type-item type5" :class="activeType === 8 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.notLeavingYetDormNum }}</div>
                    <div class="type-name">未离</div>
                  </div>
                </div> -->
              </template>
              <template v-else-if="filterForm.timeType[0] == 2 || filterForm.timeType[0] == 4">
                <!-- <div class="type-box">
                  <div @click="changeType(5)" class="type-item type2" :class="activeType === 5 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.normalNumberOfReturnees }}</div>
                    <div class="type-name">正常归寝</div>
                  </div>
                </div> -->
                <div class="type-box" v-if="tabActive != 2">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">

                    <div class="type-name" :class="activeType === 2 ? 'type-num_active' : ''">晚归</div>
                    <div class="type-num" :class="activeType === 2 ? 'type-num_active' : ''">{{ typeNum.lateDormNum
                      }}<span class="type_unit">人</span></div>
                  </div>
                </div>
                <!-- <div class="type-box">
                  <div @click="changeType(3)" class="type-item type5" :class="activeType === 3 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.notReturnedNum }}</div>
                    <div class="type-name">未归</div>
                  </div>
                </div> -->
              </template>
              <template v-else>
                <!-- <div class="type-box">
                  <div @click="changeType(0)" class="type-item type2" :class="activeType === 0 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.atDormNum }}</div>
                    <div class="type-name">在寝</div>
                  </div>
                </div>
                <div class="type-box">
                  <div @click="changeType(1)" class="type-item type3" :class="activeType === 1 ? 'type3ac' : ''">
                    <div class="type-num">{{ typeNum.notDormNum }}</div>
                    <div class="type-name">不在寝</div>
                  </div>
                </div> -->
              </template>
            </template>

            <div class="type-box">
              <div @click="changeType(10)" class="type-item type4" :class="activeType === 10 ? 'type4ac' : ''">

                <div class="type-name" :class="activeType === 10 ? 'type-num_active' : ''">
                  <img class="type-img" src="./qjzq.png" />
                  <span>请假在寝</span>
                </div>
                <div class="type-num" :class="activeType === 10 ? 'type-num_active' : ''">{{ typeNum.leaveAtDormNum
                  }}<span class="type_unit">人</span></div>
              </div>
            </div>
            <div class="type-box">
              <div @click="changeType(11)" class="type-item type7" :class="activeType === 11 ? 'type7ac' : ''">

                <div class="type-name" :class="activeType === 11 ? 'type-num_active' : ''">
                  <img class="type-img" src="./qjlx.png" />
                  <span>请假离校</span>
                </div>
                <div class="type-num" :class="activeType === 11 ? 'type-num_active' : ''">{{ typeNum.leaveOutSchoolNum
                  }}<span class="type_unit">人</span></div>
              </div>
            </div>

            <!-- 留宿人员  -->
            <div class="type-box" v-if="tabActive != 2">
              <div @click="changeType(13)" class="type-item type7" :class="activeType === 13 ? 'type7ac' : ''">

                <div class="type-name" :class="activeType === 13 ? 'type-num_active' : ''">
                  <img class="type-img" src="./ls.png" />
                  <span>假期留宿</span>
                </div>
                <div class="type-num" :class="activeType === 13 ? 'type-num_active' : ''">{{ typeNum.accommodateNum
                  }}<span class="type_unit">人</span></div>
              </div>
            </div>



          </div>
        </div>
      </div>
      <!-- 下方列表 -->
      <div class="list-content">
        <div class="floor-info" v-if="buildAndDormList && buildAndDormList.length > 0">
          <!-- 左侧宿舍楼和楼层展示 -->
          <div class="floor-left">
            <van-collapse v-model="activeBuilding" accordion @change="changeCollapse">


              <van-collapse-item v-for="build in buildAndDormList" :title="build.dormOrganName"
                :name="build.dormOrganId" :class="activeBuildingRecord == build.dormOrganId ? 'build-item-active' : ''">
                <div v-for="floor in build.childList" class="floor-item"
                  :class="activeFloor == floor.dormOrganId ? 'floor-item-active' : ''" @click="changeFloor(floor)">
                  {{ floor.dormOrganName }}
                </div>
              </van-collapse-item>

            </van-collapse>
          </div>


          <!-- 右侧房间床位展示 -->
          <div class="floor-right floor_right_bottom">
            <div class="statis-info">
              <div class="statis-content">

                <!-- 左侧宿舍楼批量选中 -->
                <div class="statis-content_left">
                  <van-checkbox v-if="isBatchProcess" class="content_left_check" shape="square" icon-size="14px"
                    @click="handleBatchFloor(buildAndDormList)"
                    :value="isFloorSelected(buildAndDormList)">全选</van-checkbox>
                </div>

                <div class="statis-content_right">
                  <div class="right_mode">
                    <div @click="changePersonShowMode(1)"
                      :class="personShowMode == 1 ? 'mode_classics mode_active' : 'mode_classics'"
                      v-if="!isBatchProcess">经典
                    </div>
                    <div @click="changePersonShowMode(2)"
                      :class="personShowMode == 2 ? 'mode_list mode_active' : 'mode_list'" v-if="!isBatchProcess">列表
                    </div>

                  </div>
                  <div class="right_name_img">
                    <img src="./tongji.png" />
                    <div>{{ getBuildName() }}</div>
                    <div>{{ buildNum.typeNum }}/{{ buildNum.personNum }}</div>
                  </div>




                </div>
              </div>

              <div class="split-bar-border"></div>
            </div>

            <!-- 床位列表展示 -->
            <div class="dorm-list">
              <div :class="personShowMode == 1 ? 'dorm-info' : 'dorm-info_mode_list'" v-for="dorm in dormList">
                <div class="dorm-name">

                  <div class="dorm-name-left">
                    <img src="./dorm-arrow.png" />
                    <div style="margin-left: 0.25rem;">{{ dorm.dormOrganName }}</div>
                  </div>

                  <!-- 房间批量选中 -->
                  <div class="dorm-name-right">

                    <!-- 处于批量处理状态并且房间有人 -->
                    <van-checkbox v-if="isBatchProcess && dorm.dormUsers.some(x => x.userId != null)"
                      class="dorm-name-right-check" shape="square" icon-size="14px" @click="handleRoom(dorm)"
                      :value="roomIsSelected(dorm)">全选</van-checkbox>
                  </div>



                </div>
                <div class="dorm-members">
                  <div class="members-item" v-for="(members, index) in dorm.dormUsers">
                    <div class="members-item-inner"
                      :class="members.userId ? (members.tolayStatus == 0 || members.tolayStatus == 2 || members.tolayStatus == 5 || members.tolayStatus == 8 || members.tolayStatus == 10 ? '' : 'no-back') : 'empty-bed'"
                      @click="openInfo(members)">
                      <div class="members-name">
                        <div class="name_index" v-if="members.userName && personShowMode == 2">
                          {{ index + 1 }}
                        </div>
                        <div :class="personShowMode == 2 ? 'members-name_text' : ''">
                          {{ members.userName }} <span class="name_text_span" v-if="personShowMode == 2">{{
      personShowMode ==
        2 && members.userName && members.organName ? ' - ' + members.organName : '' }}</span>
                        </div>


                      </div>
                      <!-- 批量处理选择 -->
                      <div class="members_radio">
                        <van-checkbox
                          :class="(members.tolayStatus == 0 || members.tolayStatus == 2 || members.tolayStatus == 5 || members.tolayStatus == 8 || members.tolayStatus == 10 ? 'custom-checkbox_1' : 'custom-checkbox_2')"
                          v-if="isBatchProcess && members.userId" icon-size="14px"
                          @click.stop="handleBed(members, $event)" :value="bedIsSelected(members)" />
                      </div>

                      <!-- 假期列表不为空 -->
                      <div v-if="judgeLeaveOrStay(members) == 'leave' || judgeLeaveOrStay(members) == 'stay'
      // (members.leaveListVMS && members.leaveListVMS.length) || members.tolayStatus == 4 || members.tolayStatus == 10 || members.tolayStatus == 11
      " class="members-tip" :style="{ background: judgeLeaveOrStay(members) == 'leave' ? '#F1C229' : '#F29225' }">
                        {{ judgeLeaveOrStay(members) == 'leave' ? '假' : '留' }}
                      </div>

                      <template v-else>
                        <template v-if="members.continuedDay">
                          <div
                            v-if="members.tolayStatus == 0 || members.tolayStatus == 2 || members.tolayStatus == 5 || members.tolayStatus == 8"
                            class="members-tip" :style="{ background: 'red' }">
                            {{ members.continuedDay }}
                          </div>
                          <div
                            v-if="members.tolayStatus == 1 || members.tolayStatus == 3 || members.tolayStatus == 6 || members.tolayStatus == 7"
                            class="members-tip" :style="{ background: '#FAAD14' }">
                            {{ members.continuedDay }}
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <!-- <div v-else class="floor-info">
          <div class="floor-left">
            <van-collapse v-model="activeBuilding" accordion @change="changeCollapse">
              <van-collapse-item v-for="build in buildList" :title="build.dormOrganName" :name="build.dormOrganId" :class="activeBuildingRecord == build.dormOrganId ? 'build-item-active' : ''">
                <div v-for="floor in build.childList" class="floor-item" :class="activeFloor == floor.dormOrganId ? 'floor-item-active' : ''" @click="changeFloor(floor)">
                  {{ floor.dormOrganName }}
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <div class="floor-right">
              <div style="min-height: 65vh;text-align: center;line-height: 30vh;color: #aaa;font-size: 0.9rem;">
                  暂无数据
              </div>
          </div>
        </div> -->
        <div v-else style="min-height: 65vh;text-align: center;line-height: 30vh;color: #aaa;font-size: 0.9rem;">
          暂无数据
        </div>
      </div>


      <infoPop @confirm="search1('rember')" ref="infoPop" @refresh="searchzhuangtai('rember')" @leave="personLeave"
        @stay="personStay">
      </infoPop>

      <!-- 宿舍状态批量处理  -->
      <batchDisposePop ref="batchDisposePopRef" @confirm="searchzhuangtai('rember')"></batchDisposePop>
      <!-- 留宿批量处理 -->
      <batchPutUpPop :selectFloor="nowSelectFloor" @close="closeLeaveOrStayPop" :stayType="stayType"
        :leaveMatters="leaveType" :batchLeaveDateInfo="batchLeaveDateInfo" @openLeaveDate="openLeaveDate"
        @openPicker="showPicker = true" ref="batchPutUpPopRef" @confirm="searchLiusu('rember')"></batchPutUpPop>


      <!-- 请假批量处理 -->
      <batchLeavePop :leaveMatters="leaveType" :filterData="filterForm" :leaveTimeOrNow="leaveTimeOrNow"
        @close="closeLeaveOrStayPop" :batchLeaveDateInfo="batchLeaveDateInfo" ref="batchLeavePopRef"
        @openLeaveDate="openLeaveDate" @openPicker="showPicker = true" @confirm="searchLiusu('rember')">
      </batchLeavePop>

      <!-- 请假事项选择 -->
      <van-popup v-model="showPicker" get-container="#app" round position="bottom">
        <van-picker title="事项" show-toolbar :columns="columns" @cancel="showPicker = false"
          @confirm="handleLeaveMatter" />
      </van-popup>

      <!-- 请假时间选择 -->
      <leaveSettingPop @getLeaveDateInfo="getLeaveDateInfo" :identity="'housemaster'" :selectFloor="nowSelectFloor"
        :personList="nowSelectPersonList" ref="leaveSettingPopRef"></leaveSettingPop>






      <filterPop @getSelectFloorTimeType="getSelectFloorTimeType" ref="filterPop" @confirm="filterPopConfirm"
        :classDataList="classDataList" :deptDataList="deptDataList" :buildList="buildList" :timeTypeList="timeTypeList">
      </filterPop>
      <!-- 底部批量 -->
      <div class="handle_popup" :style="{ bottom: buttonBottom + 'px', right: buttonRight + 'px' }"
        @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">


        <img class="handle_popup_img" src="./chuli_popup.png" @click="() => {
            this.isBatchProcess = !this.isBatchProcess
            this.nowSelectPersonList = []
            this.nowSelectFloor = ''
        }" />

        <div @click="() => {
      this.isBatchProcess = !this.isBatchProcess
      this.nowSelectPersonList = []
      this.nowSelectFloor = ''
    }" class="handle_popup_text">
          {{ isBatchProcess ? '取消批量' : '批量处理' }}
        </div>
        <!-- 功能 -->
        <div :class="isBatchProcess ? 'expand_div expand_open ' : 'expand_div expand_close'">
          <!-- 留宿处理  -->
          <div @click="handleStayProcess"
            :class="isBatchProcess ? 'expand_div_item expand_div_item_show' : 'expand_div_item expand_div_item_hidden'">
            <img class="expand_div_item_img" src="./batch_stay.png" />
            <span class="expand_div_item_text">留宿处理</span>
          </div>
          <!-- 请假处理  -->
          <div @click="handleLeaveProcess"
            :class="isBatchProcess ? 'expand_div_item expand_div_item_show' : 'expand_div_item expand_div_item_hidden'">
            <img class="expand_div_item_img" src="./batch_ leave.png" />
            <span class="expand_div_item_text">请假处理</span>
          </div>

          <!-- 在寝状态处理  -->
          <div @click="handleBatchSign"
            :class="isBatchProcess ? 'expand_div_item expand_div_item_show' : 'expand_div_item expand_div_item_hidden'">
            <img class="expand_div_item_img" src="./batch_dorm.png" />
            <span class="expand_div_item_text">在寝状态处理</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-permission">
        <div class="permission-msg">您没有使用权限</div>
        <img class="permission-bg" src="./filter-bg.png" />
      </div>
    </template>
  </div>
</template>

<script>
import infoPop from './infoPop';
import filterPop from './filterPop';
import filterDate from './filterDate';

// 宿舍归寝状态批量处理
import batchDisposePop from './batchDisposePop.vue';
// 请假批量处理
import batchLeavePop from './batchLeavePop.vue';
// 留宿人员批量处理 
import batchPutUpPop from './batchPutUpPop.vue';

// 请假时间设置
import leaveSettingPop from './leaveSettingPop.vue';

import moment from 'moment';
export default {
  components: {
    infoPop,
    filterPop,
    batchLeavePop,
    filterDate,
    batchPutUpPop,
    leaveSettingPop,
    batchDisposePop
  },
  name: 'go-back',
  data() {
    return {
      tabActive: '',
      columns: ['事假', '病假', '其他'],
      showAll: false,
      errorMsg: '',
      schoolId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).schoolId : '1070770900580810752',
      teacherId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).id : '1500216794534588416',
      // 时段信息
      timeTypeList: [],
      // 班级信息
      classDataList: [],
      // 部门信息
      deptDataList: [],
      // 宿舍楼信息
      buildAndDormList: [],
      // 类型选中
      activeType: '',
      // 展开楼
      activeBuilding: null,
      // 上次点击展开记录用来回显名字
      activeBuildingRecord: null,
      // 选中楼层
      activeFloor: null,
      typeNum: {
        personNum: 0,
        atDormNum: 0,
        notDormNum: 0,
        leaveDormNum: 0,
        leaveAtDormNum: 0,
        leaveOutSchoolNum: 0,

        // 留宿人员 
        accommodateNum: 0,
        lateDormNum: 0,
        attendanceNum: 0, // 考勤人数
        noAttendanceNum: 0, // 不考勤人数
        lateDepartureDormNum: 0,
        normalNumberOfReturnees: 0,
        normalNumberOfDepartures: 0,
        notReturnedNum: 0,
        notLeavingYetDormNum: 0
      },
      buildNum: {
        typeNum: 0,
        personNum: 0
      },
      filterForm: {
        buildList: ['all'],
        classList: ['all'],
        deptList: [],
        timeType: [],
        date: moment(new Date()).format('YYYY-MM-DD'),
        userName: null
      },
      tabType: null,
      // 批量处理相关参数
      isBatchProcess: false,

      // 宿舍楼是否全选
      floorShowAll: true,

      // 当前选中的要处理的人员
      nowSelectPersonList: [],
      // 当前选中的要处理人员的楼层
      nowSelectFloor: '',

      // 拖拽参数
      isDragging: false,

      startX: 0,
      startY: 0,
      buttonBottom: 16,
      buttonRight: 9,
      baseBottom: 16,
      showPicker: false,

      // 批量请假时间选择数据
      batchLeaveDateInfo: {},

      // 请假事项
      leaveType: '事假',

      // 当前点击的人员相关信息
      nowHandleClickPersonInfo: {},

      selectTimeType: 1,

      // 当前人员的展示模式
      personShowMode: 1, // 1 经典 2 列表

      // 请假方式 1 实时请假 2 时段请假
      leaveTimeOrNow: 1,

      stayType: 1 // 1 老师留宿 2 宿管留宿
    };
  },
  mounted() {
    const loading = this.$toast.loading({
      duration: 0,
      message: '加载中',
      forbidClick: true,
      getContainer: '#app'
    });
    // this.gettimeType();
    this.getFilter()
      .then(res => {
        // loading.clear();
        this.search();
      })
      .catch(e => {
        loading.clear();
        if (e.code == 501) {
          this.errorMsg = e.msg;
        }
        this.$toast.fail({ getContainer: '#app', message: e.msg });
      });
  },
  computed: {
    dormList: {

      get() {
        // 获取选中元素
        let selectObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor ? this.activeFloor : this.activeBuildingRecord, 'childList');
        let tempBuildAndDormList = [];
        if (selectObj) {
          this.getLeafItem(tempBuildAndDormList, selectObj.childList);
        }
        return tempBuildAndDormList;
      },
      set() { }
    },
    dormStatusList: {
      get() {
        if (this.activeType !== 0 && this.activeType !== 1) {
          if (this.activeType === '') {
            return [];
          }
          return [this.activeType];
        } else {
          if (this.activeType == 0) {
            return [0, 2, 5, 8, 10];
          }
          if (this.activeType == 1) {
            return [1, 3, 6, 7, 11];
          }

          return [];
        }
      }
    }
  },
  methods: {
    // 点击打开时间选择弹窗
    openLeaveDate(type) {
      console.log('type', type)
      this.batchLeaveDateInfo.type = type
      this.$refs.leaveSettingPopRef.open(this.batchLeaveDateInfo);
    },

    // 关闭请假或留宿弹窗进行数据清除
    closeLeaveOrStayPop() {
      this.batchLeaveDateInfo = {}
      this.leaveType = '事假'
    },

    // 人员展示模式
    changePersonShowMode(type) {
      this.personShowMode = type
    },


    // 单人请假
    async personLeave() {
      console.log('this.filterForm', this.filterForm)
      this.leaveTimeOrNow = 2
      // return
      const res = await this.$https.getLeaveDateTime({
        dormId: this.nowSelectFloor,
        timeType: this.filterForm.timeType.length ? this.filterForm.timeType[0] : undefined,
        schoolId: this.schoolId,
        signDate: this.filterForm.date
      })

      if (res.code == 200) {
        this.batchLeaveDateInfo = {
          startDate: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
          startTime: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          endDate: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
          endTime: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          endDateType: 1,
          startDateType: 1,
          startSelectTimeType: 'start',
          endSelectTimeType: 'start',
          startTimeType: res.data.startType,
          endTimeType: res.data.endType,
          type: this.selectTimeType
        }
        this.$refs.batchLeavePopRef.open({
          findDate: this.filterForm.date,
          userId: this.nowHandleClickPersonInfo.userId,
          nowSelectPersonList: [this.nowHandleClickPersonInfo],
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
          dormOrganId: this.nowSelectFloor
        });
      } else {
        this.batchLeaveDateInfo = {
          startDate: moment(this.filterForm.date, 'YYYY-MM-DD').format('YYYY年MM月DD日'),
          startTime: moment().format('HH:mm'),
          startDateType: 2,
          type: this.selectTimeType
        }
        this.$refs.batchLeavePopRef.open({
          findDate: this.filterForm.date,
          userId: this.nowHandleClickPersonInfo.userId,
          nowSelectPersonList: [this.nowHandleClickPersonInfo],
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
          dormOrganId: this.nowSelectFloor
        });
      }



    },




    // 单人留宿
    async personStay() {
      this.stayType = 2
      // 时段留宿
      const res = await this.$https.getAccommodateDateTime({
        dormId: this.nowSelectFloor,
        timeType: this.filterForm.timeType.length ? this.filterForm.timeType[0] : undefined,
        schoolId: this.schoolId,
        signDate: this.filterForm.date
      })

      if (res.code == 200) {
        this.batchLeaveDateInfo = {
          startDate: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
          startTime: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          endDate: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
          endTime: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          endDateType: 1,
          startDateType: 1,
          startSelectTimeType: 'start',
          endSelectTimeType: 'start',
          startTimeType: res.data.startType,
          endTimeType: res.data.endType,
          type: this.selectTimeType
        }
        this.$refs.batchPutUpPopRef.open({
          findDate: this.filterForm.date,
          userId: this.nowHandleClickPersonInfo.userId,
          nowSelectPersonList: [this.nowHandleClickPersonInfo],
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
          dormOrganId: this.nowSelectFloor
        });
      } else {
        this.batchLeaveDateInfo = {
          startDate: moment(this.filterForm.date, 'YYYY-MM-DD').format('YYYY年MM月DD日'),
          startTime: moment().format('HH:mm'),
          startDateType: 2,
          type: this.selectTimeType
        }
        this.$refs.batchPutUpPopRef.open({
          findDate: this.filterForm.date,
          userId: this.nowHandleClickPersonInfo.userId,
          nowSelectPersonList: [this.nowHandleClickPersonInfo],
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
          dormOrganId: this.nowSelectFloor
        });
      }



    },


    // 添加
    handleLeaveMatter(value) {
      console.log(value)
      this.showPicker = false
      this.leaveType = value
    },


    // 判断 留宿 / 请假 / 久进未出
    judgeLeaveOrStay(data) {
      if (data.leaveListVMS && data.leaveListVMS.length) { // 若有请假 ，判断有无留宿记录 
        if (data.accommodateListVMS && data.accommodateListVMS.length) {
          // 判断请假时间和留宿时间的先后顺序
          if (moment(data.accommodateListVMS[0]).isBefore(data.leaveListVMS[0])) { // 判断留宿时间是否在请假时间之前
            return 'leave'
          } else {
            return 'stay'
          }
        } else {
          return 'leave'
        }
        return 'stay'
      } else { // 若无请假 ， 判断有无留宿记录
        if (data.accommodateListVMS && data.accommodateListVMS.length) { // 有留宿记录 
          return 'stay'
        } else { // 无留宿记录
          if (data.tolayStatus == 4 || data.tolayStatus == 10 || data.tolayStatus == 11) {
            return 'leave'
          } else {
            return false
          }
        }
      }
    },
    getLeaveDateInfo(data) {
      this.batchLeaveDateInfo = data;
    },



    // 根据 老师的id 获取当前宿舍的                                                 
    getFilter() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(`student-consumer/api/dormitory/getOrgDataByTeacherId`, {
            params: {
              teacherId: this.teacherId,
              schoolId: this.schoolId
            }
          })
          .then(res => {
            if (res.code == 200) {
              this.classDataList = res.data.classDataList ? res.data.classDataList : [];
              this.buildList = res.data.dormDataList ? res.data.dormDataList : [];
              this.deptDataList = res.data.deptDataList ? res.data.deptDataList : [];
              this.showAll = true;
              resolve(res);
            } else {
              this.showAll = false;
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    gettimeType() {
      this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`, {
          dormOrganIds: this.handleBuild(),
        })
        .then(res => {
          if (res.code == 200) {
            this.timeTypeList = res.data;
          } else {
            this.timeTypeList = [];
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },


    // 根据选中的宿舍楼获取时段
    getSelectFloorTimeType(dormIds) {

      this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`, {
          dormOrganIds: dormIds,
        })
        .then(res => {
          if (res.code == 200) {
            this.timeTypeList = res.data;
          } else {
            this.timeTypeList = [];
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },

    async getTotalData() {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        // classIds: this.handleClass(),
        orgIds: orgIds,
        attendanceType: this.tabActive,
        dormOrganIds: this.handleBuild(),
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };
      await this.axios
        .post(`student-consumer/api/dormitory/getDormStatisticsDataNew`, filterObj)
        .then(res => {
          if (res.code == 200) {
            this.typeNum.personNum = res.data.personNum;
            this.typeNum.atDormNum = res.data.atDormNum;
            this.typeNum.notDormNum = res.data.notDormNum;
            this.typeNum.leaveDormNum = res.data.leaveDormNum;
            this.typeNum.lateDormNum = res.data.lateDormNum;


            this.typeNum.leaveAtDormNum = res.data.leaveAtDormNum;
            this.typeNum.leaveOutSchoolNum = res.data.leaveOutSchoolNum;
            this.typeNum.accommodateNum = res.data.accommodateNum;
            // 考勤人数
            this.typeNum.attendanceNum = res.data.attendanceNum;
            // 不考勤人数
            this.typeNum.noAttendanceNum = res.data.noAttendanceNum;
            this.typeNum.lateDepartureDormNum = res.data.lateDepartureDormNum;
            this.typeNum.normalNumberOfReturnees = res.data.normalNumberOfReturnees;
            this.typeNum.normalNumberOfDepartures = res.data.normalNumberOfDepartures;
            this.typeNum.notReturnedNum = res.data.notReturnedNum;
            this.typeNum.notLeavingYetDormNum = res.data.notLeavingYetDormNum;
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },


    // 获取默认的宿舍楼相关配置
    async getDormData(type,activeId = this.handleBuild()[0]) {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        orgIds: orgIds,
        // classIds: this.handleClass(),
        attendanceType: this.tabActive,
        dormOrganIds: this.handleBuild(),
        buildingId: this.activeBuilding ? this.activeBuilding : activeId,
        dormStatus: this.activeType,
        dormStatusList: this.dormStatusList,
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };

      // 获取宿舍数据
      const res1 = await this.axios
        .post(`student-consumer/api/dormitory/getDormReturnToBedData`, filterObj)
        .then(res => {
          if (res.data && res.data.dormDataVMS) {
            this.buildAndDormList = res.data.dormDataVMS;
            if (type == 'rember') {
              // 保持宿舍/层数选定记录
              let buildObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeBuilding, 'childList');
              let floorObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor, 'childList');
              if (!buildObj) {
                this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
                this.activeBuildingRecord = this.activeBuilding;
              }
              if (!buildObj && !floorObj) {
                this.activeFloor = this.buildAndDormList[0] && this.buildAndDormList[0].childList[0] ? this.buildAndDormList[0].childList[0].dormOrganId : null;
              }
            } else {
              // 第一次进来
              this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
              this.activeBuildingRecord = this.activeBuilding;
              this.activeFloor = null;
            }
            this.getDormStatisticsNum(this.buildAndDormList[0].atDormUserNum, this.buildAndDormList[0].dormUserNum);
          } else {
            this.buildAndDormList = [];
            this.activeBuilding = null;
            this.activeBuildingRecord = null;
            this.activeFloor = null;
            this.buildNum.personNum = 0;
            this.buildNum.typeNum = 0;
          }
          return res;
        })
        .catch(e => {
          return e;
        });
      return res1;
    },
    async getDormData2(type,activeId = this.handleBuild()[0]) {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        orgIds: orgIds,
        // classIds: this.handleClass(),
        attendanceType: this.tabActive,
        dormOrganIds: this.handleBuild(),
        buildingId: activeId,
        dormStatus: this.activeType,
        dormStatusList: this.dormStatusList,
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };

      // 获取宿舍数据
      const res1 = await this.axios
        .post(`student-consumer/api/dormitory/getDormReturnToBedData`, filterObj)
        .then(res => {
          if (res.data && res.data.dormDataVMS) {
            this.buildAndDormList = res.data.dormDataVMS;
            if (type == 'rember') {
              // 保持宿舍/层数选定记录
              let buildObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeBuilding, 'childList');
              let floorObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor, 'childList');
              if (!buildObj) {
                this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
                this.activeBuildingRecord = this.activeBuilding;
              }
              if (!buildObj && !floorObj) {
                this.activeFloor = this.buildAndDormList[0] && this.buildAndDormList[0].childList[0] ? this.buildAndDormList[0].childList[0].dormOrganId : null;
              }
            } else {
              // 第一次进来
              this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
              this.activeBuildingRecord = this.activeBuilding;
              this.activeFloor = null;
            }
            this.getDormStatisticsNum(this.buildAndDormList[0].atDormUserNum, this.buildAndDormList[0].dormUserNum);
          } else {
            this.buildAndDormList = [];
            this.activeBuilding = null;
            this.activeBuildingRecord = null;
            this.activeFloor = null;
            this.buildNum.personNum = 0;
            this.buildNum.typeNum = 0;
          }
          return res;
        })
        .catch(e => {
          return e;
        });
      return res1;
    },
    async getDormData3(type,activeId = this.handleBuild()[0]) {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        orgIds: orgIds,
        // classIds: this.handleClass(),
        attendanceType: this.tabActive,
        dormOrganIds: this.handleBuild(),
        // buildingId: this.activeBuilding ? this.activeBuilding : activeId,
        dormStatus: this.activeType,
        dormStatusList: this.dormStatusList,
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };

      // 获取宿舍数据
      const res1 = await this.axios
        .post(`student-consumer/api/dormitory/getDormReturnToBedData`, filterObj)
        .then(res => {
          if (res.data && res.data.dormDataVMS) {
            this.buildAndDormList = res.data.dormDataVMS;
            if (type == 'rember') {
              // 保持宿舍/层数选定记录
              let buildObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeBuilding, 'childList');
              let floorObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor, 'childList');
              if (!buildObj) {
                this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
                this.activeBuildingRecord = this.activeBuilding;
              }
              if (!buildObj && !floorObj) {
                this.activeFloor = this.buildAndDormList[0] && this.buildAndDormList[0].childList[0] ? this.buildAndDormList[0].childList[0].dormOrganId : null;
              }
            } else {
              // 第一次进来
              this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
              this.activeBuildingRecord = this.activeBuilding;
              this.activeFloor = null;
            }
            this.getDormStatisticsNum(this.buildAndDormList[0].atDormUserNum, this.buildAndDormList[0].dormUserNum);
          } else {
            this.buildAndDormList = [];
            this.activeBuilding = null;
            this.activeBuildingRecord = null;
            this.activeFloor = null;
            this.buildNum.personNum = 0;
            this.buildNum.typeNum = 0;
          }
          return res;
        })
        .catch(e => {
          return e;
        });
      return res1;
    },
    // 点击别的宿舍楼获取别的宿舍楼的数据
    async getEachDormData (id) {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        orgIds: orgIds,
        // classIds: this.handleClass(),
        attendanceType: this.tabActive,
        dormOrganIds: this.handleBuild(),
        buildingId: id,
        dormStatus: this.activeType,
        dormStatusList: this.dormStatusList,
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };

      // 获取宿舍数据
      const res1 = await this.axios
        .post(`student-consumer/api/dormitory/getDormReturnToBedData`, filterObj)
        .then(res => {
          if (res.data && res.data.dormDataVMS) {
            this.buildAndDormList = res.data.dormDataVMS;

            // 获取当前查询的的宿舍楼的人员入住情况
            let data = this.buildAndDormList.find(item => item.dormOrganId == id)
            this.getDormStatisticsNum(data.atDormUserNum, data.dormUserNum);
          } else {
           
          }
          return res;
        })
        .catch(e => {
          return e;
        });
      return res1;
    },






    async getDormStatisticsNum(a, b) {
      // 统计查询
      this.$nextTick(async () => {
        let orgIds = [...this.handleClass(), ...this.handleDept()];
        let filterObj = {
          orgIds: orgIds,
          // classIds: this.handleClass(),
          dormOrganId: this.activeFloor ? this.activeFloor : this.activeBuildingRecord,
          dormStatus: this.activeType === '' ? 0 : this.activeType,
          dormStatusList: this.activeType === '' ? [0, 2, 5, 8] : this.dormStatusList,
          findDate: this.filterForm.date,
          userName: this.filterForm.userName,
          schoolId: this.schoolId,
          teacherId: this.teacherId,
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
        };
        // 获取楼层和宿舍右上角统计
        // await this.axios.post(`student-consumer/api/dormitory/getDormStatisticsNum`, filterObj).then(res => {
        //   if (res.code == 200) {
        //     this.buildNum.personNum = res.data.personNum;
        //     this.buildNum.typeNum = res.data.typeNum;
        //   } else {
        //     this.$toast.fail({ getContainer: '#app', message: res.msg });
        //   }
        // });
        this.buildNum.personNum = b;
        this.buildNum.typeNum = a;
      });
    },
    handleClass() {
      let tempClassVal = [];
      if (this.filterForm.classList.indexOf('all') != -1) {
        // 有全部情况
        if (this.filterForm.classList[0] == 'all') {
          // 第一个为全部情况
          this.getLeaf(tempClassVal, this.classDataList);
        } else {
          // 其余某个为全部，递归父级;
          let classItem = this.findItem(this.classDataList, 'id', this.filterForm.classList[this.filterForm.classList.indexOf('all') - 1]);
          if (classItem) {
            this.getLeaf(tempClassVal, classItem.children);
          }
        }
      } else {
        // let classItem = this.findItem(this.classDataList, 'id', this.filterForm.classList[this.filterForm.classList.length - 1]);
        // if(classItem){
        //   if(classItem.children&&classItem.children.length>0){
        //     this.getLeaf(tempClassVal, classItem.children);
        //   }else{
        //     tempClassVal = [classItem.id]
        //   }
        // }
        tempClassVal = [this.filterForm.classList[this.filterForm.classList.length - 1]];
      }
      return tempClassVal;
    },
    handleDept() {
      let tempDeptVal = [];
      if (this.filterForm.deptList.indexOf('all') != -1) {
        // 有全部情况
        if (this.filterForm.deptList[0] == 'all') {
          // 第一个为全部情况
          this.getLeaf(tempDeptVal, this.deptDataList);
        } else {
          // 其余某个为全部，递归父级;
          let deptItem = this.findItem(this.deptDataList, 'id', this.filterForm.deptList[this.filterForm.deptList.indexOf('all') - 1]);
          if (deptItem) {
            this.getLeaf(tempDeptVal, deptItem.children);
          }
        }
      } else {
        let deptItem = this.findItem(this.deptDataList, 'id', this.filterForm.deptList[this.filterForm.deptList.length - 1]);
        if (deptItem) {
          if (deptItem.children && deptItem.children.length > 0) {
            this.getLeaf(tempDeptVal, deptItem.children);
          } else {
            tempDeptVal = [deptItem.id];
          }
        }
        // this.getLeaf(tempDeptVal, deptItem.children);
        // tempDeptVal = [this.filterForm.deptList[this.filterForm.classList.length - 1]];
      }
      return tempDeptVal;
    },
    handleBuild() {
      let tempBuildVal = [];
      if (this.filterForm.buildList.indexOf('all') != -1) {
        tempBuildVal = this.buildList && this.buildList.map(item => {
          return item.dormOrganId;
        });
      } else {
        tempBuildVal = JSON.parse(JSON.stringify(this.filterForm.buildList));
      }
      return tempBuildVal;
    },
    getBuildName() {
      if (this.activeFloor) {
        let floorItem = this.findItem(this.buildList, 'dormOrganId', this.activeFloor, 'childList');
        if (floorItem) {
          let buildItem = this.findItem(this.buildList, 'dormOrganId', floorItem.parentId, 'childList');
          return buildItem ? `${buildItem.dormOrganName}/${floorItem.dormOrganName}` : '';
        } else {
          return '';
        }
      } else {
        let buildItem = this.findItem(this.buildList, 'dormOrganId', this.activeBuildingRecord, 'childList');
        return buildItem ? buildItem.dormOrganName : '';
      }
    },
    getFloorTypeNum() {
      let num = 0;
      this.dormList.map(item => {
        let tempMemberList = item.dormMember.filter(child => {
          return child.userId;
        });
        num += tempMemberList.length;
      });
      return num;
    },
    onAnimationEnd() {
      if (this.isBatchProcess) {
        // 动画完成后展示子元素内容
        this.$el.querySelector('.expand_div').classList.add('animated');
      } else {
        // 动画完成后隐藏子元素内容
        this.$el.querySelector('.expand_div').classList.remove('animated');
      }
    },
    filterPopConfirm(data) {
      this.activeType = '';
      this.filterForm = data;
      this.search3();
    },
    async getTabType() {
      let filterObj = {
        dormOrganIds: this.handleBuild()
      };
      const result = await this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`, filterObj)
        .then(res => {
          this.tabType = res.data;
          return res;
        })
        .catch(e => {
          return e;
        });
      return result;
    },
    async search(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });




      // 如果没选中时段且是今天那么调用后台获取当前时段
      // if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
      //   this.getTabType();
      // } else {
      //   this.tabType = null;
      // }

      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData2(type);
      if (res.code == 200) {
        loading.clear();
        this.nowSelectPersonList = []
        this.nowSelectFloor = ''
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },
    async searchzhuangtai(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });




      // 如果没选中时段且是今天那么调用后台获取当前时段
      // if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
      //   this.getTabType();
      // } else {
      //   this.tabType = null;
      // }

      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData3(type);
      if (res.code == 200) {
        loading.clear();
        this.nowSelectPersonList = []
        this.nowSelectFloor = ''
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },
    async search3(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });




      // 如果没选中时段且是今天那么调用后台获取当前时段
      // if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
      //   this.getTabType();
      // } else {
      //   this.tabType = null;
      // }

      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData3(type);
      if (res.code == 200) {
        loading.clear();
        this.nowSelectPersonList = []
        this.nowSelectFloor = ''
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },


    async search1(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      this.$refs.infoPop.closePop();



      // 如果没选中时段且是今天那么调用后台获取当前时段
      // if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
      //   this.getTabType();
      // } else {
      //   this.tabType = null;
      // }

      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData(type);
      if (res.code == 200) {
        loading.clear();
        this.nowSelectPersonList = []
        this.nowSelectFloor = ''
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },

    async searchLiusu(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      this.$refs.infoPop.closePop();



      // 如果没选中时段且是今天那么调用后台获取当前时段
      // if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
      //   this.getTabType();
      // } else {
      //   this.tabType = null;
      // }

      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData3(type);
      if (res.code == 200) {
        loading.clear();
        this.nowSelectPersonList = []
        this.nowSelectFloor = ''
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },


    // 修改折叠建筑
    changeCollapse(e) {
      console.log('点击了展开项',e,this.activeBuilding)


      // 点击展开项后调用接口获取相应楼层的数据
      if(e) {
        this.getEachDormData(e)
      }

      if (e) {
        let a = this.buildAndDormList.find(item => item.dormOrganId == e);
        // 选中建筑清空楼层
        this.activeBuildingRecord = e;
        this.activeFloor = null;
        this.getDormStatisticsNum(a.atDormUserNum, a.dormUserNum);
      } else {
        let a = this.buildAndDormList.find(item => item.dormOrganId == this.activeBuilding);
        this.activeFloor = null;
        this.getDormStatisticsNum(a.atDormUserNum, a.dormUserNum);
      }
    },
    // 修改在寝状态
    async changeType(type) {
      if (this.activeType === type) {
        this.activeType = ''
      } else {
        this.activeType = type
      }
      this.nowSelectPersonList = []
      this.nowSelectFloor = ''
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData3();
      if (res.code == 200) {
        loading.clear();
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },

    // 修改考勤不考勤状态
    async changeAttendType(type) {
      this.tabActive = type;
      this.nowSelectPersonList = []
      this.nowSelectFloor = ''
      if (this.activeType == 13) {
        this.activeType = ''
      }
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData3();
      if (res.code == 200) {
        loading.clear();
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },
    changeFloor(floor) {
      // 修改层数只查询楼层信息
      this.activeFloor = floor.dormOrganId;
      this.getDormStatisticsNum(floor.atDormUserNum, floor.dormUserNum);
    },
    moreFilter() {
      this.gettimeType()
      this.$refs.filterPop.open(this.filterForm);
    },
    openInfo(data) {
      if (this.isBatchProcess) { //批量处理选择人员


        if (this.nowSelectPersonList.find(item => item.userId == data.userId)) {
          // 取消选中
          this.nowSelectPersonList = this.nowSelectPersonList.filter(item => item.userId != data.userId)
          if (this.nowSelectPersonList.length == 0) {
            this.nowSelectFloor = ''
          }
        } else {

          if (this.nowSelectPersonList.length) {
            // 判断选中的人员是否是同一宿舍楼
            if (this.nowSelectFloor == this.activeBuildingRecord) {
              this.nowSelectPersonList.push(data)
              this.nowSelectFloor = this.activeBuildingRecord
            } else {
              this.$toast({ getContainer: '#app', message: '请选择同一宿舍楼下的人员，进行批量处理' });
              return
            }
          } else {
            // 选中
            this.nowSelectPersonList.push(data)
            this.nowSelectFloor = this.activeBuildingRecord

          }

        }



      } else {
        if (data.userId) {
          console.log('data', data)
          this.nowHandleClickPersonInfo = data
          this.nowSelectFloor = this.activeBuildingRecord
          this.$refs.infoPop.open(data, this.filterForm.date, this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null);
        }
      }

    },
    getLeaf(valueList, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children && list[i].children.length > 0) {
          this.getLeaf(valueList, list[i].children);
        } else {
          valueList.push(list[i].id);
        }
      }
    },
    getLeafItem(valueList, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].childList && list[i].childList.length > 0) {
          this.getLeafItem(valueList, list[i].childList);
        } else {
          valueList.push(list[i]);
        }
      }
    },
    findItem(list, key, value, children = 'children') {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item[key] === value) {
          return item;
        }
        if (item[children] && item[children].length > 0) {
          if (this.findItem(item[children], key, value)) {
            return this.findItem(item[children], key, value);
          }
        }
      }
      return null;
    },
    getParams(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      return r ? unescape(r[2]) : '';
    },









    // 批量处理相关方法

    // 判断床位是否选中
    bedIsSelected(data) {
      if (this.nowSelectPersonList.find(item => item.userId == data.userId)) {
        return true
      } else {
        return false
      }
    },

    // 点击床位选中
    handleBed(data, e) {
      e.stopPropagation()
      console.log('data', data, this.nowSelectPersonList)
      // if (this.nowSelectPersonList.find(item => item.userId == data.userId)) {
      //   console.log('1')
      //   // 取消选中
      //   this.nowSelectPersonList = this.nowSelectPersonList.filter(item => item.userId != data.userId)
      //   if (!this.nowSelectPersonList.length) {
      //     this.nowSelectFloor = ''
      //   }
      // } else {
      //   console.log('2')
      //   if (this.nowSelectPersonList.length) { // 有选中的值 判断是否是同一宿舍楼
      //     // 判断选中的人员是否是同一宿舍
      //     if (this.nowSelectFloor == this.activeBuildingRecord) {
      //       this.nowSelectPersonList.push(data)
      //     } else {
      //       this.$toast.fail({ getContainer: '#app', message: '请选择同一宿舍楼下的人员' });
      //       return
      //     }
      //   } else {
      //     // 选中
      //     this.nowSelectPersonList.push(data)
      //     this.nowSelectFloor = this.activeBuildingRecord
      //   }

      // }
    },

    // 点击房间选中
    handleRoom(data) {
      let arr = data.dormUsers.filter(x => x.userId != null)
      if (this.isContained(this.nowSelectPersonList, arr)) {
        // 取消选中
        this.nowSelectPersonList = this.nowSelectPersonList.filter(item => !arr.find(x => x.userId == item.userId))
        if (!this.nowSelectPersonList.length) {
          this.nowSelectFloor = ''
        }
      } else {
        if (this.nowSelectPersonList.length) { // 有选中的值 判断是否是同一宿舍楼
          // 判断选中的人员是否是同一宿舍
          if (this.nowSelectFloor == this.activeBuildingRecord) {
            this.nowSelectPersonList = this.nowSelectPersonList.concat(arr)
            this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.userId === item.userId && item.dormOrganId === item.dormOrganId
              ))
            );
            this.nowSelectFloor = this.activeBuildingRecord

          } else {
            this.$toast({ getContainer: '#app', message: '请选择同一宿舍楼下的人员，进行批量处理' });
            return
          }

        } else {
          // 选中
          this.nowSelectPersonList = this.nowSelectPersonList.concat(arr)
          this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
            index === self.findIndex((t) => (
              t.userId === item.userId && item.dormOrganId === item.dormOrganId
            ))
          );
          this.nowSelectFloor = this.activeBuildingRecord
        }
      }

    },
    // 判断房间是否选中
    roomIsSelected(data) {
      let arr = data.dormUsers.filter(x => x.userId != null)
      let bol = this.isContained(this.nowSelectPersonList, arr)
      return bol
    },

    isContained(array1, array2) {
      return array2.every(item2 =>
        array1.some(item1 => (
          item1.userId === item2.userId && item1.dormOrganId === item2.dormOrganId
        ))
      );
    },


    // 点击宿舍楼选中
    handleBatchFloor(data) {
      console.log('点击宿舍楼选中', this.nowSelectPersonList, this.activeBuildingRecord, this.activeFloor)


      // 当前选中宿舍楼
      let nowFloor = this.activeBuildingRecord
      // 当前选中宿舍楼楼层
      let nowFloorList = this.activeFloor
      // 判断当前选中的是楼层还是整个宿舍楼
      if (nowFloorList) { // 当前选中的是某个宿舍的某一层
        // 判断当前楼层是否全选
        let arr = data.find(item => item.dormOrganId == nowFloor).childList.find(x => x.dormOrganId == nowFloorList)

        let totalPerson = []
        arr.childList && arr.childList.forEach(item => {
          let arr = item.dormUsers.filter(x => x.userId != null)
          totalPerson = totalPerson.concat(arr)
        })

        // 判断是否全选
        if (this.isContained(this.nowSelectPersonList, totalPerson)) {
          this.nowSelectPersonList = this.nowSelectPersonList.filter(item => !totalPerson.find(x => x.userId == item.userId))
          if (!this.nowSelectPersonList.length) {
            this.nowSelectFloor = ''
          }
        } else {

          if (this.nowSelectPersonList.length) {
            if (this.nowSelectFloor == this.activeBuildingRecord) {
              this.nowSelectPersonList = this.nowSelectPersonList.concat(totalPerson)
              this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
                index === self.findIndex((t) => (
                  t.userId === item.userId && item.dormOrganId === item.dormOrganId
                ))
              );
              this.nowSelectFloor = this.activeBuildingRecord
            } else {
              this.$toast({ getContainer: '#app', message: '请选择同一宿舍楼下的人员，进行批量处理' });
              return
            }
          } else {
            this.nowSelectPersonList = this.nowSelectPersonList.concat(totalPerson)
            this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.userId === item.userId && item.dormOrganId === item.dormOrganId
              ))
            );
            this.nowSelectFloor = this.activeBuildingRecord
          }

        }
      } else { // 当前选中的某栋宿舍楼
        let obj = data.find(item => item.dormOrganId == nowFloor)
        let totalPerson = []
        obj.childList.forEach(item => {
          item.childList.forEach(s => {
            let arr = s.dormUsers.filter(x => x.userId != null)
            totalPerson = totalPerson.concat(arr)
          })
        })
        if (this.isContained(this.nowSelectPersonList, totalPerson)) { // 取消全选

          this.nowSelectPersonList = this.nowSelectPersonList.filter(item => !totalPerson.find(x => x.userId == item.userId))
          if (!this.nowSelectPersonList.length) {
            this.nowSelectFloor = ''
          }
        } else {
          if (this.nowSelectPersonList.length) {
            if (this.nowSelectFloor == this.activeBuildingRecord) {
              this.nowSelectPersonList = this.nowSelectPersonList.concat(totalPerson)
              this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
                index === self.findIndex((t) => (
                  t.userId === item.userId && item.dormOrganId === item.dormOrganId
                ))
              );
              this.nowSelectFloor = this.activeBuildingRecord
            } else {
              this.$toast({ getContainer: '#app', message: '请选择同一宿舍楼下的人员，进行批量处理' });
              return
            }
          } else {
            this.nowSelectPersonList = this.nowSelectPersonList.concat(totalPerson)
            this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.userId === item.userId && item.dormOrganId === item.dormOrganId
              ))
            );
            this.nowSelectFloor = this.activeBuildingRecord
          }
        }
      }
    },

    // 判断楼层是否全选
    isFloorSelected(data) {
      let newData = JSON.parse(JSON.stringify(data))
      // 当前选中宿舍楼
      let nowFloor = this.activeBuildingRecord
      // 当前选中宿舍楼楼层
      let nowFloorList = this.activeFloor
      if (nowFloorList) { // 当前选中的是某个宿舍的某一层
        // 判断当前楼层是否全选
        let arr = newData.find(item => item.dormOrganId == this.activeBuilding).childList.find(x => x.dormOrganId == this.activeFloor)
        // 获取所有宿舍人员
        let totalPerson = []
        arr.childList && arr.childList.forEach(item => {
          let arr = item.dormUsers.filter(x => x.userId != null)
          totalPerson = totalPerson.concat(arr)
        })
        // 判断是否全选
        return this.isContained(this.nowSelectPersonList, totalPerson)
      } else { // 当前选中的某栋宿舍楼
        let obj = newData.find(item => item.dormOrganId == nowFloor)
        console.log('obj', obj)
        let totalPerson = []
        obj.childList.forEach(item => {
          item.childList.forEach(s => {
            let arr = s.dormUsers.filter(x => x.userId != null)
            totalPerson = totalPerson.concat(arr)
          })
        })
        // 判断是否全选
        return this.isContained(this.nowSelectPersonList, totalPerson)
      }
    },

    // 点击在寝状态处理
    handleBatchSign() {
      if (this.nowSelectPersonList.length) {
        console.log('this.filterForm.timeType[0] ', this.filterForm.timeType[0])
        this.$refs.batchDisposePopRef.open({
          findDate: this.filterForm.date,
          userId: this.nowSelectPersonList[0].userId,
          nowSelectPersonList: this.nowSelectPersonList,
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
          dormOrganId: this.nowSelectFloor
        });

      } else {
        this.$toast({ getContainer: '#app', message: '请选择人员' });
        return
      }
    },

    // 点击批量请假处理
    async handleLeaveProcess() {
      console.log('this.filterForm', this.filterForm)


      // 获取当前默认请假时间

      if (this.nowSelectPersonList.length) {
        console.log('this.filterForm', this.filterForm, this.nowSelectFloor)
        this.leaveTimeOrNow = 2
        const res = await this.$https.getLeaveDateTime({
          dormId: this.nowSelectFloor,
          timeType: this.filterForm.timeType.length ? this.filterForm.timeType[0] : undefined,
          schoolId: this.schoolId,
          signDate: this.filterForm.date
        })
        if (res.code == 200) {

          this.batchLeaveDateInfo = {
            startDate: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
            startTime: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            endDate: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
            endTime: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            endDateType: 1,
            startDateType: 1,
            startSelectTimeType: 'start',
            endSelectTimeType: 'start',
            startTimeType: res.data.startType,
            endTimeType: res.data.endType,
            type: this.selectTimeType
          }
          this.$refs.batchLeavePopRef.open({
            findDate: this.filterForm.date,
            userId: this.nowSelectPersonList[0].userId,
            nowSelectPersonList: this.nowSelectPersonList,
            timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
            dormOrganId: this.nowSelectFloor
          });
        } else {
          this.batchLeaveDateInfo = {
            startDate: moment(this.filterForm.date, 'YYYY-MM-DD').format('YYYY年MM月DD日'),
            startTime: moment().format('HH:mm'),
            startDateType: 2,
            type: this.selectTimeType
          }
          this.$refs.batchLeavePopRef.open({
            findDate: this.filterForm.date,
            userId: this.nowSelectPersonList[0].userId,
            nowSelectPersonList: this.nowSelectPersonList,
            timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
            dormOrganId: this.nowSelectFloor
          });
        }

      } else {
        this.$toast({ getContainer: '#app', message: '请选择人员' });
        return
      }
    },


    // 点击开始或结束时间打开
    handleClickStartOrEndTime() {

    },




    // 点击批量留宿处理
    async handleStayProcess() {
      if (this.nowSelectPersonList.length) {
        this.stayType = 2
        // 获取默认留宿时间

        const res = await this.$https.getAccommodateDateTime({
          dormId: this.nowSelectFloor,
          timeType: this.filterForm.timeType.length ? this.filterForm.timeType[0] : undefined,
          schoolId: this.schoolId,
          signDate: this.filterForm.date
        })
        if (res.code == 200) {
          // 设置选中时间默认值
          this.batchLeaveDateInfo = {
            startDate: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
            startTime: moment(res.data.startTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            endDate: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日'),
            endTime: moment(res.data.endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            endDateType: 1,
            startDateType: 1,
            startSelectTimeType: 'start',
            endSelectTimeType: 'start',
            startTimeType: res.data.startType,
            endTimeType: res.data.endType,
            type: this.selectTimeType
          }
          this.$refs.batchPutUpPopRef.open({
            findDate: this.filterForm.date,
            userId: this.nowSelectPersonList[0].userId,
            nowSelectPersonList: this.nowSelectPersonList,
            timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
            dormOrganId: this.nowSelectFloor
          });
        } else {
          // 设置选中时间默认值
          this.batchLeaveDateInfo = {
            startDate: moment(this.filterForm.date, 'YYYY-MM-DD').format('YYYY年MM月DD日'),
            startTime: moment().format('HH:mm'),
            startDateType: 2,
            type: this.selectTimeType
          }
          this.$refs.batchPutUpPopRef.open({
            findDate: this.filterForm.date,
            userId: this.nowSelectPersonList[0].userId,
            nowSelectPersonList: this.nowSelectPersonList,
            timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null,
            dormOrganId: this.nowSelectFloor
          });


        }







      } else {
        this.$toast({ getContainer: '#app', message: '请选择人员' })
      }
    },

    // 拖拽开始
    handleTouchStart(e) {
      e.stopPropagation()
      this.isDragging = true;
      const touch = e.touches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
    },

    // 拖拽结束后
    handleTouchEnd(e) {
      e.stopPropagation()
      this.isDragging = false
      this.baseBottom = this.buttonBottom
    },
    // 拖拽过程中w
    handleTouchMove(e) {
      e.preventDefault(); // 阻止默认的滚动行为
      if (!this.isDragging) return;
      const touch = e.touches[0];
      this.buttonBottom = Math.max(10, this.baseBottom - (touch.clientY - this.startY))
    }
  }
};
</script>

<style lang="scss" scoped>
// 批量处理展开动画
@keyframes expandopen {
  from {
    width: 0;
  }

  to {
    width: 17.5586rem;
    // width: 12.0265rem;
  }
}

@keyframes expandclose {
  from {
    width: 17.5586rem;
    // width: 12.0265rem;
  }

  to {
    width: 0;
  }
}

@keyframes itemShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.header-filter {
  width: 100%;
  position: relative;

  .filter-bg {
    height: 8.2rem;
    width: 100%;
    position: absolute;
    z-index: 1;
  }

  .filter-content {
    position: relative;
    z-index: 5;
  }

  .filter-row1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .7212rem;

    .filter_tabs {
      display: flex;
      flex: 1;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #FFFFFF;
      // line-height: 0px;
      text-align: left;
      box-sizing: border-box;
      font-style: normal;
      justify-content: space-around;

      .filter_tabs_item {
        position: relative;
        margin-right: .5409rem;
      }

      .filter_tabs_item_active {

        &::before {
          content: '';
          width: 1.9231rem;
          position: absolute;
          height: .1202rem;
          left: 50%;
          bottom: -0.4808rem;
          transform: translateX(-50%);
          background-color: #fff;

        }
      }

      // .filter_tabs_item::nthe() {

      // }
    }

    .filter_date {
      display: flex;
      align-items: center;
    }

    ::v-deep.date-box {

      .date-arrow,
      .date-show {
        color: #fff;
      }
    }

    .filter-input {
      // padding-left: 0.7rem;
      padding-right: 0rem;
      flex: 1;
      flex-shrink: 0;
      display: flex;
      // border-radius: 0.9375rem;
      overflow: hidden;
      align-items: center;

      .search-icon {
        color: #fff;
        text-align: center;
        width: 2rem;
        flex-shrink: 0;
        // padding-top: 0.2rem;
        // border-radius: 0.5rem;
        height: 1.875rem;
        line-height: 1.875rem;
        background-color: #3775ff;
        padding-right: 0.3rem;
        border-radius: 0 0.9375rem 0.9375rem 0;
        border: 1px solid #fff;
        // background-color: #3775ff;

        // img {
        //   height: 0.9rem;
        // }
      }

      input {
        border-radius: 0.9375rem 0 0 0.9375rem;
        width: calc(100% - 2rem);
        box-sizing: border-box;
        height: 1.875rem;
        border: 0;
        outline: 0;
        flex: 1;
        padding: 0.4375rem 0 0.4375rem 0.7rem;
        font-size: 0.75rem;
        color: #333;
        background: #fff;

        &::placeholder {
          color: #999;
        }
      }
    }

    .more-filter {
      margin-left: .601rem;
      width: .8413rem;
      height: .8813rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .filter-row3 {
    margin: 0 0.75rem;
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0px 0px .601rem .0601rem rgba(12, 51, 138, 0.08);
    border-radius: .2404rem;
    background-color: #fff;


    // margin-top: 1rem
    .type-box {
      // padding: 0 0.2rem;
      width: 33.3%;
      // background: #FFFFFF;


      .type-item {
        height: 4.5rem;
        width: 100%;
        padding: 0.5rem 0.5rem;
        border-radius: none;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-left: 1.6827rem;
        // align-items: center;

        &::before {
          content: '';
          height: 1.7428rem;
          width: .0601rem;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          background-color: #E8E8E8;
          position: absolute;
        }

        &:nth-child(3n)::before {
          content: '';
          background-color: transparent;
          width: 0px;
        }


        .type-num {
          font-size: 1.3221rem;
          color: #333333;

          .type_unit {
            font-weight: 400;
            font-size: .7212rem;
            margin-left: .2404rem;
          }
        }

        .type-num_active {
          color: #3775FF;
        }

        .type-name {
          // margin-left: 0.3rem;
          display: flex;
          align-items: center;
          color: #999999;
          margin-top: .7212rem;
          margin-bottom: .2404rem;
          font-size: 0.7rem;

          .type-img {
            width: .7212rem;
            height: .7212rem;
            margin-right: .2404rem;
          }
        }

        .type-num_active {
          color: #3775FF;
        }
      }

      .type1 {}

      .type1ac {

        color: #3775FF;
      }

      .type2 {
        // background: url(./type2.png);
        // background-size: 100% 100%;
      }

      .type2ac {

        color: #3775FF;
      }

      .type3 {
        // background: url(./type3.png);
        // background-size: 100% 100%;
      }

      .type3ac {

        color: #3775FF;
      }

      .type4 {
        // background: url(./type4.png);
        // background-size: 100% 100%;
      }

      .type4ac {

        color: #3775FF;
      }

      .type5 {
        // background: url(./type5.png);
        color: #3775FF;
        // background-size: 100% 100%;
      }

      .type5ac {

        color: #3775FF;
      }

      .type6 {
        // background: url(./type6.png);
        // background-size: 100% 100%;
        color: #3775FF;
      }

      .type6ac {

        color: #3775FF;
      }

      .type7 {
        // background: url(./type7.png);
        // background-size: 100% 100%;
        // color: #3775FF;
      }

      .type7ac {

        color: #3775FF;
      }
    }


  }

  .grade-tab {
    flex: 1;
    padding: 0 0.75rem;
    overflow: hidden;

    .grade-inner {
      width: 100%;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .class-tab {
    width: 100%;
    padding: 0 0.75rem;
    overflow: hidden;

    .class-inner {
      width: 100%;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

.list-content {
  margin-top: 0.5rem;
  position: relative;
  z-index: 5;

  .floor-info {
    display: flex;

    .floor-left {
      width: 5.625rem;
      padding-top: 0.5rem;
      flex-shrink: 0;
      height: 100%;
      overflow: auto;
      max-height: 80vh;

      &::-webkit-scrollbar {
        display: none;
      }

      .build-item-active::before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0.625rem;
        height: 1rem;
        width: 0.25rem;
        background: url('./collapse-active-icon.png');
        background-size: 100% 100%;
        z-index: 1;
      }

      ::v-deep.van-collapse {
        .van-collapse-item {
          .van-cell {
            position: relative;

            .van-cell__title {
              font-weight: bold;
              line-height: 1rem;
            }

            .van-icon {
              display: none;
            }
          }

          // .van-collapse-item__title--expanded::before {
          //   content: '';
          //   display: block;
          //   position: absolute;
          //   left: 0;
          //   top: 0.625rem;
          //   height: 1rem;
          //   width: 0.25rem;
          //   background: url('./collapse-active-icon.png');
          //   background-size: 100% 100%;
          // }
          .van-collapse-item__content {
            padding: 0 1rem;
            color: #333;

            .floor-item {
              // colo
              padding: 0.625rem 0;
            }

            .floor-item-active {
              color: #3775ff;
            }
          }
        }
      }
    }

    .floor-right {
      flex: 1;
      padding-top: 1rem;


      .statis-info {
        padding-right: 1rem;
        padding-left: 0.5rem;
        text-align: right;
        position: relative;

        .statis-content {
          display: flex;
          justify-content: space-between;

          .statis-content_left {
            display: flex;
            align-items: center;

            .content_left_check {

              ::v-deep.van-checkbox__icon {
                .van-icon {
                  border-radius: .1203rem;
                  border: .0601rem solid #E8E8E8;
                }

              }

              ::v-deep.van-checkbox__label {
                margin-left: .3608rem;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .8419rem;
                color: #333333;
                line-height: 1.2026rem;
                text-align: left;
                font-style: normal;
              }
            }


          }

          .statis-content_right {
            display: flex;
            align-items: center;
            flex: 1;
            justify-content: space-between;
            line-height: 1.25rem;

            .right_mode {
              display: flex;

              .mode_classics,
              .mode_list {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .7212rem;
                color: #666666;
                line-height: .9615rem;
                text-align: center;
                font-style: normal;
                text-transform: none;
                background-color: #F6F9FC;
                padding: .1202rem .4808rem;
              }

              .mode_active {
                color: #fff;
                background-color: #3775FF;
              }

              .mode_classics {
                border-radius: .2404rem 0px 0px .2404rem;
              }

              .mode_list {
                border-radius: 0px .2404rem .2404rem 0px;
              }
            }

            .right_name_img {
              display: inline-flex;
              align-items: center;
              line-height: 1.25rem;

              &>*+* {
                margin-left: 0.5rem;
                font-size: 0.875rem;
              }

              img {
                height: 0.8rem;
              }
            }

          }


        }

        .split-bar-border {
          width: 100%;
          height: 1px;
          background-color: #e8e8e8;
          margin-top: 0.3rem;
        }
      }

      .dorm-list {
        min-height: 65vh;
        max-height: 80vh;
        overflow: auto;
        width: 100%;
        padding: 0.625rem 0.5rem;

        .dorm-info {
          &:not(:first-child) {
            margin-top: 0.6rem;
          }

          .dorm-name {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .dorm-name-left {
              display: flex;
              align-items: center;

              img {
                height: 0.8rem;
              }
            }

            .dorm-name-right {
              .dorm-name-right-check {
                ::v-deep.van-checkbox__icon {
                  .van-icon {
                    border-radius: .1203rem;
                    border: .0601rem solid #E8E8E8;
                  }

                }

                ::v-deep.van-checkbox__label {
                  margin-left: .3608rem;
                  font-family: Microsoft YaHei, Microsoft YaHei;
                  font-weight: 400;
                  font-size: .8419rem;
                  color: #333333;
                  line-height: 1.2026rem;
                  text-align: left;
                  font-style: normal;
                }
              }

            }

          }

          .dorm-members {
            display: flex;
            margin-top: 0.625rem;
            flex-wrap: wrap;

            .members-item {
              // display: inline-block;
              width: 33.3%;
              text-align: center;
              color: white;
              font-size: 0.875rem;
              padding-right: 0.3rem;
              padding-bottom: 0.3rem;

              .members-item-inner {
                background-color: #3775ff;
                padding: 0.625rem 0;
                border-radius: 0.3rem;
                position: relative;
                overflow: hidden;

                .members-tip {
                  border-radius: 0 0 0 0.6rem;
                  position: absolute;
                  right: 0;
                  top: 0;
                  height: 0.875rem;
                  width: 1.375rem;
                  font-size: 0.625rem;
                  color: #fff;
                }

                .members-name {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  line-clamp: 1;
                  -webkit-line-clamp: 1;
                  /* 可以显示的行数，超出部分用...表示*/
                  -webkit-box-orient: vertical;

                  &>div {
                    height: 1.1rem;
                    line-height: 1.1rem;
                  }
                }

                .members_radio {
                  position: absolute;
                  top: .1804rem;
                  left: .1804rem;



                  .custom-checkbox_1 {
                    ::v-deep .van-icon {
                      background-color: #fff;
                    }

                    ::v-deep .van-checkbox__icon--checked .van-icon {
                      color: #1989fa;
                      background-color: #fff;
                      border-color: #fff;
                    }
                  }

                  .custom-checkbox_2 {

                    ::v-deep .van-checkbox__icon--checked .van-icon {
                      color: #fff;
                      background-color: #1989fa;
                      border-color: #1989fa;
                    }
                  }
                }
              }

              .empty-bed {
                background-color: transparent;
                // border: 1px dashed #aaa;
                background-color: #eee;
                border-radius: 0.3rem;

                .members-tip {
                  display: none;
                }
              }

              .no-back {
                // opacity: 0.5;
                background-color: #eee;
                color: #666;
              }
            }

            .members-item:nth-child(3n+3) {
              padding-right: 0;
            }

          }
        }

        .dorm-info_mode_list {
          padding: .601rem;
          background-color: #F6F9FC;
          border-radius: .3606rem;

          &:not(:first-child) {
            margin-top: 0.6rem;
          }

          .dorm-name {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .dorm-name-left {
              display: flex;
              align-items: center;

              img {
                height: 0.8rem;
              }
            }

            .dorm-name-right {
              .dorm-name-right-check {
                ::v-deep.van-checkbox__icon {
                  .van-icon {
                    border-radius: .1203rem;
                    border: .0601rem solid #E8E8E8;
                  }

                }

                ::v-deep.van-checkbox__label {
                  margin-left: .3608rem;
                  font-family: Microsoft YaHei, Microsoft YaHei;
                  font-weight: 400;
                  font-size: .8419rem;
                  color: #333333;
                  line-height: 1.2026rem;
                  text-align: left;
                  font-style: normal;
                }
              }

            }

          }

          .dorm-members {
            display: flex;
            margin-top: 0.625rem;
            flex-wrap: wrap;

            .members-item {
              // display: inline-block;
              width: 100%;
              text-align: center;
              color: #3775FF;
              font-size: 0.875rem;
              padding-bottom: 0.3rem;

              .members-item-inner {
                background-color: #fff;
                padding: 0.625rem 0;
                border-radius: 0.3rem;
                position: relative;
                overflow: hidden;

                .members-tip {
                  border-radius: 0 0 0 0.6rem;
                  position: absolute;
                  right: 0;
                  top: 0;
                  height: 0.875rem;
                  width: 1.375rem;
                  font-size: 0.625rem;
                  color: #fff;
                }

                .members-name {
                  // background-color: red;
                  display: flex;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  // display: -webkit-box;
                  line-clamp: 1;
                  -webkit-line-clamp: 1;
                  /* 可以显示的行数，超出部分用...表示*/
                  -webkit-box-orient: vertical;

                  .name_index {
                    font-family: DIN Next LT Pro, DIN Next LT Pro;
                    font-weight: bold;
                    font-size: .9615rem;
                    color: #3775FF;
                    line-height: .9615rem;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    margin-right: .9014rem;
                    margin-left: 1.3221rem;
                  }

                  &>div {
                    height: 1.1rem;
                    line-height: 1.1rem;
                  }

                  .members-name_text {
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    line-clamp: 1;
                    -webkit-line-clamp: 1;
                    /* 可以显示的行数，超出部分用...表示*/
                    -webkit-box-orient: vertical;

                    .name_text_span {
                      font-family: Microsoft YaHei, Microsoft YaHei;
                      font-weight: 400;
                      font-size: .7212rem;
                      line-height: .9615rem;
                      text-align: left;
                      font-style: normal;
                      text-transform: none;
                    }
                  }
                }

                .members_radio {
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  left: .1804rem;



                  .custom-checkbox_1 {
                    ::v-deep .van-checkbox__icon--checked .van-icon {
                      color: #fff;
                      background-color: #1989fa;
                      border-color: #1989fa;
                    }
                  }

                  .custom-checkbox_2 {

                    ::v-deep .van-checkbox__icon--checked .van-icon {
                      color: #fff;
                      background-color: #1989fa;
                      border-color: #1989fa;
                    }
                  }
                }
              }

              .empty-bed {
                background-color: transparent;
                // border: 1px dashed #aaa;
                background-color: #fff;
                border-radius: 0.3rem;

                .members-tip {
                  display: none;
                }
              }

              .no-back {
                // opacity: 0.5;
                background-color: #fff;
                color: #666;
              }
            }

            .members-item:nth-child(3n+3) {
              padding-right: 0;
            }

          }
        }

      }
    }
  }
}

.split-bar {
  height: 0.8rem;
}

.textalign-left {
  ::v-deep.van-tabs__wrap {
    height: 2rem;

    .van-tab {
      flex: none;
      padding: 0 1rem;
    }

    .van-tabs__nav--line {
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
    }

    .van-tabs__line {
      bottom: 0;
    }

    .van-tab--active {
      font-weight: bold;
    }
  }
}

.no-permission {
  position: relative;
  width: 100%;

  .permission-msg {
    text-align: center;
    position: relative;
    z-index: 2;
    line-height: 20vh;
  }

  .permission-bg {
    top: 0;
    left: 0;
    height: 25vh;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
}

.handle_popup {
  position: fixed;
  z-index: 999;
  // bottom: 1.6837rem;

  // right: .9385rem;
  right: 9px;
  bottom: 16px;




  height: 4.8707rem;
  width: 7.7132rem;

  .handle_popup_img {
    height: 100%;
    position: absolute;
    z-index: 1;
    right: 0;
  }

  .handle_popup_text {
    width: 4.5701rem;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    font-weight: 400;
    font-size: .8419rem;
    color: #fff;

    line-height: 1.6236rem;
    text-align: center;
    font-style: normal;
  }

  .expand_div {
    position: absolute;
    height: 4.3897rem;
    right: 3.8485rem;
    bottom: 0;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
    border-radius: 6px 6px 6px 6px;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .expand_div_item {
      // margin: 0 1.2026rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      opacity: 0;
      transition: opacity .5s ease-in-out;

      .expand_div_item_img {
        height: 1.5634rem;
        width: 1.5634rem;
        margin-bottom: .4811rem;
      }

      .expand_div_item_text {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: .8419rem;
        color: #666666;
        line-height: 1.1425rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }

    .expand_div_item_show {
      animation: itemShow 1.2s forwards;
    }

    .expand_div_item_hidden {
      opacity: 0;
    }
  }

  // 关闭批量处理
  .expand_close {
    display: none;
  }

  // 打开批量处理
  .expand_open {
    animation: expandopen .3s ease-out forwards;
    will-change: width;
  }
}
</style>
